import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['priorityForm', 'defaultForm', 'input'];
  submit(e) {
    const value = this.inputTarget.value;
     if (value && e.currentTarget == this.defaultFormTarget) {
      e.preventDefault();
      this.priorityFormTarget.requestSubmit();
     } else if (!value && e.currentTarget == this.priorityFormTarget) {
        e.preventDefault();
       this.defaultFormTarget.requestSubmit();
     }
  }
}
